// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__s6vUh","pageBanner":"Layout_pageBanner__nhu-e","pageBox":"Layout_pageBox__v9M7u"};